import { FC } from 'react'
import styled from 'styled-components'

interface IFEmptyAreaProps {
  className?: string
}

const EmptyArea: FC<IFEmptyAreaProps> = ({ className }) => {
  return <StyledWrapper className={className} />
}

export default EmptyArea

const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.background.bg_1};
`
